import ClassificationViewState from '../store/schema/ClassificationViewState';
import MessageClassificationType from 'owa-service/lib/contract/MessageClassificationType';
import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import addMessageClassificationInfoBar from './addMessageClassificationInfoBar';
import setMessageClassification from '../actions/setMessageClassification';

export default function classifyMessage(
    viewState: ClassificationViewState,
    infoBarViewState: InfoBarHostViewState,
    classification: MessageClassificationType,
    composeId: string
) {
    const { messageClassification } = viewState;
    if (!messageClassification) {
        addMessageClassificationInfoBar(infoBarViewState, composeId);
    }
    setMessageClassification(viewState, classification);
}
